import React, { useContext, useState } from 'react';
import context from '@catalogo/ui-americanas-desktop-product-review/src/context';

const withFeedbackReview = (Component: any) => (props: any) => {
  const { config, actionFeedback, dispatchMetrics } = useContext(context);
  const [like, setLike] = useState(false);
  const [dislike, setDislike] = useState(false);
  const { customer, history } = config;
  const handleLike = () => {
    setLike(!like);
    if (!like) {
      dispatchMetrics('event:track', {
        category: 'avaliacao-pdp',
        action: 'avaliacao-feedback',
        label: 'curti',
      });
    }
  };

  const handleDislike = () => {
    setDislike(!dislike);
    if (!dislike) {
      dispatchMetrics('event:track', {
        category: 'avaliacao-pdp',
        action: 'avaliacao-feedback',
        label: 'nao-curti',
      });
    }
  };

  const handleFeedback = async (vote: string, id: string) => {
    if (!customer?.id) {
      return history.push('#modal-login');
    }
    const result = await actionFeedback({
      variables: {
        reviewId: id,
        vote: vote,
      },
    });
    if (result) {
      if (vote == 'upvote') {
        handleLike();
        setDislike(false);
        return;
      }
      if (vote == 'downvote') {
        handleDislike();
        setLike(false);
        return;
      }
    }
  };

  const data = { ...props, handleFeedback: handleFeedback, like: like, dislike: dislike };
  return <Component {...data} />;
};

export default withFeedbackReview;
export { withFeedbackReview };
